import { useParams } from "react-router-dom";
import BackButton from "../../../../../components/BackButton/BackButton";
import SchoolDetails from "./SchoolDetails";
import { GET_SCHOOL_BY_ID } from "../Querries";
import { useQuery } from "@apollo/client";
import { LoadingSpinner } from "./SchoolList";

function SinglesSchoolCard() {
  const { id } = useParams();
  const {
    data: schoolData,
    loading,
    error,
  } = useQuery(GET_SCHOOL_BY_ID, {
    variables: { school_id: id },
    skip: !id,
  });

  if (loading) {
    console.log(id);
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <div className="text-center py-8 text-red-500">
        Error loading school details
      </div>
    );
  }
  const school = schoolData?.getallschool.data || null;

  return (
    <div>
      <BackButton to="/school_profile" label={school?.name} />
      {school ? (
        <SchoolDetails school={[school[0]]} />
      ) : (
        <div className="text-center py-8 text-gray-500">School not found</div>
      )}
    </div>
  );
}

export default SinglesSchoolCard;
